export default __webpack_public_path__ + "static/media/screen.51704f33.svg";